
import React from 'react';
import './Connector.css'; 

const Connector = () => {
  return (
    <div>
    <div className='connector-container'>
      <h2>All in all, this evaluation of BRI brings out many flaws from its intention, methods used, and impacts received from participating countries. Despite the convincing benefits of the development programme, the flaws presenting itself seems to outweigh its merits. However, some might argue that we are similarly thinking like the Westerners, threatened by a new power. With that, we will now analyse OBOR and the Western Naysayers. </h2>
    </div>

    <div className='otherthesis-container'>
        <h2>There are many Western naysayers to the One Belt, One Road (OBOR) initiative because the profound impact and far-reaching implications of the project on global affairs compel Western leaders to take action and use the voice of naysayers to advance their geopolitical agenda and safeguard their own interests.</h2>
    </div>

    </div>

);
};

export default Connector;
